import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import { useRecruitStore } from 'src/stores/RecruitStore';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

const menuProps = {
    PaperProps: {
        sx: {
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:46,
    width: '100%',
    textAlign:'center',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& svg': {
      right: '30%',
      transform: 'translateX(50%)',
      position: 'absolute',
      pointerEvents: 'none',
    },
}

const DropBoxSx = {
    justifyContent: 'center',
    textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const RecruitSelectYear = () => {
    const today = new Date()
    const thisYear = today.getFullYear();
    const yearContent = [thisYear-1,thisYear,thisYear+1]
    const setField = useRecruitStore((state)=>state.setField)
    const year = useRecruitStore((state)=>state.year)

    const handleYearChange = (e:SelectChangeEvent<string>)=>{
        setField('year',e.target.value)
    }

  return (
      <Select
          value={year}
          onChange={handleYearChange}
          renderValue={(selected) => `${selected}년`}
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {yearContent.map((content) => (
              <MenuItem value={content.toString()} sx={DropBoxSx}>
                  {content}년
              </MenuItem>
          ))}
      </Select>
  )
}

export default RecruitSelectYear